import React, { FC, useEffect, useRef, useState } from 'react';

import { Button } from 'antd';
import { config } from 'config/config';
import LoginForm from 'src/components/forms/consumer/LoginFormConsumer';
import { breakpoints, customFormatMessage } from 'utils';
import { PlatformEnum } from 'src/shared/enums';
import { useRouter } from 'next/router';
import { useWindowSize } from 'utils';
import classNames from 'classnames';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import routePaths from 'config/routes';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import LoginExperiences from './LoginExperiences';

const {
  CON_ARGENTINA,
  CON_BRAZIL,
  CON_CHILE,
  CON_COLOMBIA,
  CON_DEUTSCHLAND,
  CON_ITALY,
  CON_MEXICO,
  CON_PERU,
  CON_PORTUGAL,
  CON_FRANCE,
  CON_SPAIN,
} = PlatformEnum;
const mapStateToProps = (state: IRootReducers) => {
  return { user: state.auth.user };
};

type Props = ReturnType<typeof mapStateToProps>;

const LoginPage: FC<Props> = ({ user }): JSX.Element => {
  const { isSM, isMDPR, isLGBG } = useWindowSize();
  const loginRef = useRef(null);
  const getLoginRef = () => {
    return loginRef;
  };
  const router = useRouter();
  const { query, pathname } = router;
  const isCampaign = !!query.campaign;
  const isPregnancy = !!query.pregnancy && query.pregnancy === 'true';
  const { isXL } = useWindowSize();
  const countryPlatform = config.APP.PLATFORM;
  const [buttonConVisible, setButtonConVisible] = useState(true);
  const buttonRef = useRef(null);
  const pregLanding =
    countryPlatform === CON_SPAIN &&
    pathname === routePaths.PAGES.LOGIN &&
    query.pregnancy === 'true';
  const [isClient, setIsClient] = useState(typeof window === 'object');
  const [mainImage, setMainImage] = useState('');
  const [showPregnancyLandingFirstTime, setShowPregnancyLandingFirstTime] =
    useState(true);

  useEffect(() => {
    if (pregLanding) {
      const observer = new IntersectionObserver(([entry]) => {
        setButtonConVisible(entry.isIntersecting);
      });

      if (buttonRef !== null) {
        observer.observe(buttonRef.current);
      }
    }
  }, [buttonRef, buttonConVisible]);

  const pregnancyMainImage = () => {
    if (isSM) {
      return pregnancyLoginImage;
    } else if (
      isClient &&
      window.innerWidth >= breakpoints.sm &&
      window.innerWidth < breakpoints.lg_bg
    ) {
      return pregnancyLoginImageTablet;
    } else return pregnancyLoginImageDesktop;
  };

  useEffect(() => {
    setIsClient(typeof window === 'object');
    setMainImage(pregnancyMainImage());
  });

  let mobileLoginImage = null;
  let desktopLoginImage = null;
  let discoveryDesktopImage = null;
  let discoveryMobileImage = null;

  const loadImagesByCountry = () => {
    switch (countryPlatform) {
      case CON_ARGENTINA:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Mobile_Spring_2023.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Desktop_Spring_2023.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_BRAZIL:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Mobile_Summer_2023.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Desktop_Summer_2023.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_CHILE:
        mobileLoginImage = `${config.APP.MEDIA_CON}BannerLogInMobile.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}BannerLogInDesktop.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_COLOMBIA:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Mobile_Spring_2023.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Desktop_Spring_2023.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_DEUTSCHLAND:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_Mobile_LogIn_Autum_2024.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_Desktop_LogIn_Autum_2024.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_ITALY:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_Mobile_LogIn_Autum_2024.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_Desktop_LogIn_Autum_2024.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_MEXICO:
        mobileLoginImage = `${config.APP.MEDIA_CON}BANNER_MOBILE_REVAMP_AUTUMN_23.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}BANNER_DESKTOP_REVAMP_AUTUMN_23.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_PERU:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Mobile_Spring_2023.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_LogIn_Desktop_Spring_2023.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      case CON_PORTUGAL:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_Mobile_LogIn_Autum_2024.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_Desktop_LogIn_Autum_2024.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop_PT.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile_PT.gif`;
        break;
      case CON_FRANCE:
        mobileLoginImage = `${config.APP.MEDIA_CON}Banner_Mobile_LogIn_Autum_2024.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}Banner_Desktop_LogIn_Autum_2024.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
      default:
        mobileLoginImage = `${config.APP.MEDIA_CON}BANNER_MOBILE_REVAMP_AUTUMN_23.png`;
        desktopLoginImage = `${config.APP.MEDIA_CON}BANNER_DESKTOP_REVAMP_AUTUMN_23.png`;
        discoveryDesktopImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Desktop.gif`;
        discoveryMobileImage = `${config.APP.CONSUMABLES.IMAGES}2023_DiscoveryJourney_BannerLogin_Mobile.gif`;
        break;
    }
  };

  const pregnancyLoginImage = `${config.APP.MEDIA_CON}pregnancyLandingImage.png`;
  const pregnancyLoginImageTablet = `${config.APP.MEDIA_CON}pregnancyMainImageSquareTablet.png`;
  const pregnancyLoginImageDesktop = `${config.APP.MEDIA_CON}pregnancyMainImageSquareDesktop.png`;

  const blockOnePregnancyMobile = `${config.APP.MEDIA_CON}pregnancyInfoOneMobile.png`;
  const blockOnePregnancyTablet = `${config.APP.MEDIA_CON}blockOneDektopImagePregnancy.png`;

  const pregnancyBlockOneInfoImage = () => {
    if (!isLGBG) return blockOnePregnancyMobile;
    else return blockOnePregnancyTablet;
  };

  const blockTwoPregnancyMobile = `${config.APP.MEDIA_CON}pregnancyInfoTwoMobile.png`;
  const blockTwoPregnancyTablet = `${config.APP.MEDIA_CON}pregnancyBlockTwoTablet.png`;

  const pregnancyBlockTwoInfoImage = () => {
    if (!isLGBG) return blockTwoPregnancyMobile;
    else return blockTwoPregnancyTablet;
  };

  const pregnancyBlockThreeVideoMobile = `${config.APP.VIDEO_CON}pregnancyVideoMobile.mp4`;
  const pregnancyBlockThreeVideoTablet = `${config.APP.VIDEO_CON}pregnancyVideoTablet.mp4`;

  const pregnancyBlockThreeVideo = () => {
    if (isMDPR) return pregnancyBlockThreeVideoMobile;
    else return pregnancyBlockThreeVideoTablet;
  };

  const selectCountry = (): string => {
    switch (countryPlatform) {
      case CON_ARGENTINA:
        return 'Argentina';
      case CON_BRAZIL:
        return 'Brasil';
      case CON_CHILE:
        return 'Chile';
      case CON_COLOMBIA:
        return 'Colombia';
      case CON_DEUTSCHLAND:
        return 'Deutschland';
      case CON_ITALY:
        return 'Italy';
      case CON_MEXICO:
        return 'México';
      case CON_PERU:
        return 'Peru';
      case CON_PORTUGAL:
        return 'Portugal';
      case CON_FRANCE:
        return 'France';
      default:
        return 'España';
    }
  };

  const discoveryLanding = () => {
    return isXL ? (
      <div ref={getLoginRef} className="login-con--discovery-container">
        <div ref={loginRef} className="login-con--wrapper-discovery-con">
          <h1 className="login-con-title-discovery">
            {customFormatMessage(
              'consumables.discovery.landing.user-not-logged.title',
              {
                country: selectCountry(),
              },
            )}
          </h1>
          <p className="login-con-subtitle-discovery">
            {customFormatMessage(
              'consumables.discovery.landing.user-not-logged.info',
            )}
          </p>
        </div>
        <div className="product-img-styles-consumables-discovery-container">
          <img
            className="product-img-styles-discovery-desktop"
            src={discoveryDesktopImage}
          />
          <img
            className="product-img-styles-discovery-mobile"
            src={discoveryMobileImage}
          />
        </div>
        <div className="login-discovery">
          <LoginForm loginRef={getLoginRef} />
        </div>
      </div>
    ) : (
      <div ref={getLoginRef} className="login-con--discovery-container">
        <div className="product-img-styles-consumables-discovery-container">
          <img
            className="product-img-styles-discovery-desktop"
            src={discoveryDesktopImage}
          />
          <img
            className="product-img-styles-discovery-mobile"
            src={discoveryMobileImage}
          />
        </div>
        <div ref={loginRef} className="login-con--wrapper-discovery-con">
          <h1 className="login-con-title-discovery">
            {customFormatMessage(
              'consumables.discovery.landing.user-not-logged.title',
              {
                country: selectCountry(),
              },
            )}
          </h1>
          <p className="login-con-subtitle-discovery">
            {customFormatMessage(
              'consumables.discovery.landing.user-not-logged.info',
            )}
          </p>
          <div className="login-discovery">
            <LoginForm loginRef={getLoginRef} />
          </div>
        </div>
      </div>
    );
  };

  const pregnancyLanding = () => {
    return (
      <>
        <div
          ref={getLoginRef}
          className={classNames('Login-component-container qr-landing')}>
          <div className="pregnancy-main-block">
            <div className="pregnancy-landing-images">
              <div className="pregnancy-landing-background-img">
                <img width={100} src={mainImage} />
              </div>
            </div>
            {user && showPregnancyLandingFirstTime ? (
              <div className="pregnancy-form-container">
                <div className="pregnancy-landing-text-block">
                  <div className="pregnancy-landing-block pregnancy-landing-block__main-title-logged">
                    <p className="pregnancy-title pregnancy-title__main-block">
                      {customFormatMessage('pregnancy.landing.title')}
                    </p>
                  </div>
                </div>
                <div ref={buttonRef} className="container-ref-landing" />
                <div className="pregnancy-landing-text-block-continue-logged">
                  <div className="pregnancy-width-continue">
                    <div
                      className={
                        buttonConVisible
                          ? 'landing-pregnancy-continue-button'
                          : 'landing-container-pregnancy-continue-button'
                      }>
                      <Link href={`${routePaths.INDEX}?pregnancy=true`}>
                        <Button
                          className={
                            buttonConVisible
                              ? 'btn-primary btn-primary--black qr-landing__login__form__button__logged pregnancyButtonCont'
                              : 'btn-primary btn-primary--black qr-landing__login__form__button__logged pregnancyButtonCont landing-button-left-margin-pregnancy'
                          }>
                          {customFormatMessage(
                            'consumables.landing.user.logged.view.experience',
                          )}
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="pregnancy-form-container">
                <div className="pregnancy-landing-text-block">
                  <div className="pregnancy-landing-block">
                    <p className="pregnancy-title pregnancy-title__main-block">
                      {customFormatMessage('pregnancy.landing.title')}
                    </p>
                    <p className="pregnancy-subtitle pregnancy-subtitle__main-block">
                      {customFormatMessage('pregnancy.landing.subtitle')}
                    </p>
                  </div>
                </div>
                <div className="login-pregnancy">
                  <div className="pregnancy-width">
                    <LoginForm
                      pregnancyLanding={pregLanding}
                      buttonRef={buttonRef}
                      loginRef={getLoginRef}
                      showUserPregnancyLanding={
                        setShowPregnancyLandingFirstTime
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="pregnancy-info">
          <div className="pregnancy-block-info-image pregnancy-block-info-image__reverse-row">
            <div className="pregnancy-image-info-styles pregnancy-image-info-styles__right">
              <img width={100} src={pregnancyBlockOneInfoImage()} />
            </div>
            <div className="pregnancy-info-block-desktop">
              <p className="pregnancy-title pregnancy-title__info">
                {customFormatMessage('pregnancy.landing.block-one.title')}
              </p>
              <p className="pregnancy-subtitle pregnancy-subtitle__info">
                {customFormatMessage('pregnancy.landing.block-one.subtitle')}
              </p>
            </div>
          </div>
          <div className="pregnancy-block-info-image pregnancy-block-info-image__row">
            <div className="pregnancy-image-info-styles pregnancy-image-info-styles__left">
              <img width={100} src={pregnancyBlockTwoInfoImage()} />
            </div>
            <div className="pregnancy-info-block-desktop">
              <p className="pregnancy-title pregnancy-title__info">
                {customFormatMessage('pregnancy.landing.block-two.title')}
              </p>
              <p className="pregnancy-subtitle pregnancy-subtitle__info">
                {customFormatMessage('pregnancy.landing.block-two.subtitle')}
              </p>
            </div>
          </div>
          <div className="pregnancy-block-info-image">
            <div className="pregnancy-image-info-styles">
              <ReactPlayer
                className="pregnancy-video"
                playing={true}
                muted={true}
                url={pregnancyBlockThreeVideo()}
              />
            </div>
          </div>
        </div>
        <LoginExperiences />
      </>
    );
  };

  const userLanding = () => {
    return (
      <>
        <div ref={loginRef} className="login-con--wrapper-con">
          <h1 className="login-con-title">
            {customFormatMessage('login.title', {
              country: selectCountry(),
            })}
          </h1>
          <p className="login-con-subtitle">
            {customFormatMessage('login.subtitle')}
          </p>
          <LoginForm loginRef={getLoginRef} />
        </div>
        <div className="Login-component-container qr-landing">
          <img
            alt=""
            loading="lazy"
            className="login-con--main-image_desktop"
            src={desktopLoginImage}
          />
          <img
            alt=""
            loading="lazy"
            className="login-con--main-image_mobile"
            src={mobileLoginImage}
          />
        </div>
        <LoginExperiences />
      </>
    );
  };

  const selectLanding = () => {
    if (isCampaign) return discoveryLanding();
    else if (isPregnancy && countryPlatform === CON_SPAIN)
      return pregnancyLanding();
    else return userLanding();
  };

  return (
    <>
      <>{loadImagesByCountry()}</>
      <>{selectLanding()}</>
    </>
  );
};

export default connect(mapStateToProps, {})(LoginPage);
